/**
 * "Try" followed by example values, one per line with a hanging indent so the
 * list lines up under itself rather than wrapping mid-run. Replaces pill
 * chips so suggestions read as a footnote rather than a control.
 */
export const Examples = ({
  items,
  onPick,
  mono = false,
}: {
  items: Array<{ value: string; label?: string }>;
  onPick: (value: string) => void;
  mono?: boolean;
}) => (
  <div className="grid grid-cols-[2.75rem_minmax(0,1fr)] text-sm leading-6 text-zinc-400">
    <span className="font-ui pt-px">Try</span>
    <ul className="min-w-0">
      {items.map((item) => (
        <li key={item.value} className="min-w-0">
          <button
            type="button"
            onClick={() => onPick(item.value)}
            title={item.label ? item.value : undefined}
            className={`block max-w-full truncate text-left text-zinc-500 transition-colors hover:text-zinc-900 focus-visible:outline-none focus-visible:text-zinc-900 ${mono ? "font-mono text-xs" : "italic"
              }`}
          >
            {item.label ?? item.value}
          </button>
        </li>
      ))}
    </ul>
  </div>
);
